"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const legacyVariableDisplayNames = Object.freeze({
    CUSTOMERS: "利用人数",
    REVENUE: "売上",
    MEMO: "メモ",
});
exports.default = legacyVariableDisplayNames;
